import { render, staticRenderFns } from "./FloatingMenu.vue?vue&type=template&id=de53e24c&scoped=true"
import script from "./FloatingMenu.vue?vue&type=script&lang=js"
export * from "./FloatingMenu.vue?vue&type=script&lang=js"
import style0 from "./FloatingMenu.vue?vue&type=style&index=0&id=de53e24c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de53e24c",
  null
  
)

export default component.exports